import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { Grid, IconButton, Typography, units } from '@hbf/dsl';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';

import { NOFOLLOW_REF, socialLinksData } from '../constants';

const useStyles = makeStyles()(() => ({
  icon: {
    backgroundColor: 'white',
    color: 'black',
    marginRight: units.rem(0.5),
    '&:hover': {
      backgroundColor: 'white',
    },

    '& > svg': {
      width: units.rem(1),
      height: units.rem(1),
    },
  },
}));

const SocialLinks: React.FC = () => {
  const { T, urlResolver } = useIntl();
  const { classes } = useStyles();

  return (
    <Grid
      container
      justifyContent="flex-end"
      alignItems="center"
      direction={{ xs: 'column-reverse', lg: 'row' }}
      mt={units.rem(1)}
      data-test-locator="Footer/SocialLinks"
    >
      <Grid
        item
        container
        alignItems="center"
        xs={12}
        md={4}
        justifyContent={{ xs: 'center', xl: 'flex-end' }}
        mb={{ xs: units.rem(1), xl: 0 }}
      >
        <Typography.Paragraph
          color="white"
          sx={{ marginRight: units.rem(0.5) }}
        >
          {T('Follow us')}
        </Typography.Paragraph>
        <div>
          {socialLinksData.map(({ socialVendor, urlBuilder, icon }) => (
            <Track
              key={socialVendor}
              name="Clicked Social icon"
              type="icon"
              socialvendor={socialVendor}
            >
              <IconButton
                href={urlResolver[urlBuilder]()}
                target="_blank"
                rel={NOFOLLOW_REF}
                className={classes.icon}
                size="large"
                data-test-locator={`Footer/Share/${socialVendor}`}
              >
                {icon}
              </IconButton>
            </Track>
          ))}
        </div>
      </Grid>
    </Grid>
  );
};

export { SocialLinks };
